import { Injectable, OnInit } from '@angular/core';
import { Http } from '@angular/http';
import { Subject } from 'rxjs/Subject';
import * as SocketIOClient from 'socket.io-client';
import * as moment from 'moment';

import { TramApiService } from './tram-api.service';
import { Tram } from './core/tram';
import { TramStop } from './core/tram-stop';

import { environment } from '../environments/environment';

@Injectable()
export class TramPositioningService {
    private wsUrl = environment.socketUrl;
    private socket: SocketIOClient.Socket;

    private subject: Subject<Tram[]>;
    private _trams: Tram[];

    get trams() {
        return this.subject.asObservable();
    }

    constructor(private api: TramApiService) {
        this.subject = new Subject();
    }

    connect() {
        this.socket = SocketIOClient.connect(this.wsUrl);
        this.socket.on('connect', () => this.onWebSocketOpen());
        this.socket.on('message', (e) => this.onWebSocketMessage(e));
        this.socket.on('disconnect', () => this.onWebSocketClose());
        this.socket.on('error', (e) => this.onWebSocketError(e));
    }

    close() {
        if (this.socket && this.socket.connected) {
            this.socket.close();
        }
    }

    private onWebSocketOpen() {
        if (this.socket.connected) {
            this.socket.send('trams.start');
        }
    }
    private onWebSocketMessage(e: any) {
        if (!e || !e.data)
            return;
        let trams = e.data.map(this.wrapTram);
        this._trams = trams;

        this.subject.next(this._trams);
    }
    private onWebSocketError(e: any) {
        console.log('WEBSOCKET:', e);
        this.socket.close();
    }
    private onWebSocketClose() {
        console.log('WEBSOCKET CLOSED');
        this.socket.close();
    }

    private wrapTram(data: any): Tram {
        let tram = data as Tram;

        if (data.nextStop) {
            let nextStop: TramStop = new TramStop();
            nextStop.stopId = data.nextStop.stopId;
            nextStop.distance = data.nextStop.distance;
            nextStop.arrivalTime = data.nextStop.arrivalTime;

            tram.nextStop = nextStop;
        }

        return tram;
    }
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/tram-positioning.service.ts